import { render, staticRenderFns } from "./SoftwareMFA.vue?vue&type=template&id=7663d805&scoped=true"
import script from "./SoftwareMFA.vue?vue&type=script&lang=js"
export * from "./SoftwareMFA.vue?vue&type=script&lang=js"
import style0 from "./SoftwareMFA.vue?vue&type=style&index=0&id=7663d805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7663d805",
  null
  
)

export default component.exports